import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { DropdownChip } from "@styleguide";
import { type Control, Controller, type UseFormSetValue } from "react-hook-form";

export interface ICoachingStepForm {
  coachingStep?: string;
}
export interface ICoachingStepProps {
  control: Control<ICoachingStepForm, void>;
  setValue: UseFormSetValue<ICoachingStepForm>;
}

export const CandidateCoachingStep = ({ control, setValue }: ICoachingStepProps) => {
  const { settings } = useGlobalContext();
  const options = settings.settingsCoachingStep?.filter((el) => el.active === true) ?? [];

  return (
    <Controller
      control={control}
      name="coachingStep"
      render={({ field: { value, onChange } }) => (
        <>
          <DropdownChip
            variant="outlined"
            options={options}
            chipSxProps={{ maxWidth: "121px" }}
            onChange={(value) => onChange(value.value)}
            value={value ?? "Choisir l'étape"}
            alwaysDisplayArrow
          />
          {value && (
            <Tooltip title={"Réinitialiser"}>
              <IconButton
                sx={{ padding: 0 }}
                aria-label="Réinitialiser"
                onClick={() => setValue("coachingStep", undefined)}
              >
                <RestoreOutlinedIcon color="primary" />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    />
  );
};
